import { NavLink } from "react-router-dom";
import { useAuth } from "../store/auth";

export function BottomNav() {
  const role = useAuth((s) => s.user?.role);

  if (role === "admin") {
    return (
      <nav className="bottom-nav" aria-label="Admin navigation">
        <div className="inner" style={{ gridTemplateColumns: "repeat(5, 1fr)" }}>
          <NavLink to="/admin" end>
            <span className="icon">▣</span>
            Overview
          </NavLink>
          <NavLink to="/capture">
            <span className="icon">⊕</span>
            Scan
          </NavLink>
          <NavLink to="/admin/import">
            <span className="icon">⬆</span>
            Import
          </NavLink>
          <NavLink to="/admin/users">
            <span className="icon">◎</span>
            People
          </NavLink>
          <NavLink to="/admin/export">
            <span className="icon">⬇</span>
            Export
          </NavLink>
        </div>
      </nav>
    );
  }

  return (
    <nav className="bottom-nav" aria-label="Main navigation">
      <div className="inner">
        <NavLink to="/" end>
          <span className="icon">☰</span>
          Open
        </NavLink>
        <NavLink to="/capture">
          <span className="icon">◎</span>
          Capture
        </NavLink>
        <NavLink to="/history">
          <span className="icon">✓</span>
          Done
        </NavLink>
      </div>
    </nav>
  );
}
